import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { LoginService } from './login.service';
import { GlobalVariables } from '../../../../global-variables';
import { UserInfoService } from 'src/app/services/user-info.service';
import { HierarchyScopeService } from 'src/app/services/hierarchy-scope.service';
import { StorageKey, StorageService } from 'src/app/services/common/storage.service';
import { AlertService } from 'src/app/services/common/alert.service';
import { RoleManagementService } from 'src/app/services/role-management.service';
import { isPartnerPortalUser, UserTypeEnum } from 'src/app/services/common/constant.service';
import QRCode from 'qrcode';
import { VcardUserService } from 'src/app/services/vcard-user.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  menuOpen = false;

  public userFullName: string = '';
  public loginResponse: any;
  public userData: any;

  public email: string = '';
  public password: string = '';

  angularProjectURL: any = '';

  submitted = false;
  loginForm: FormGroup;

  isPopupVisible = true;
  hidePassword = true;

  menuRights: any[] = [];
  // selectedComponent = "login"
  currentTab = 'login'
  // [
  //   { menu: 'Dashboard', isAdd: true, isEdit: true, isDelete: true, isView: true },
  //   { menu: 'Campaigns', isAdd: true, isEdit: true, isDelete: true, isView: true },
  //   { menu: 'Campaign Stats', isAdd: true, isEdit: true, isDelete: true, isView: true },
  //   { menu: 'Retail Stores', isAdd: true, isEdit: true, isDelete: true, isView: true },
  //   { menu: 'Reedem Coupons', isAdd: true, isEdit: true, isDelete: true, isView: true },
  //   { menu: 'Validate & Reedem', isAdd: true, isEdit: true, isDelete: true, isView: true },
  //   { menu: 'Products', isAdd: true, isEdit: true, isDelete: true, isView: true },
  //   { menu: 'Users', isAdd: true, isEdit: true, isDelete: true, isView: true },
  //   { menu: 'Subscriptions', isAdd: true, isEdit: true, isDelete: true, isView: true },
  //   { menu: 'Role Management', isAdd: true, isEdit: true, isDelete: true, isView: true },
  // ];

  get f() { return this.loginForm.controls; }
 currency="test---" 
  constructor(private loginService: LoginService,
    private router: Router,
    private userInfoService: UserInfoService,
    private storageService: StorageService,
    private alertService: AlertService,
    private roleManagementService: RoleManagementService,
    private vcardUserService: VcardUserService,
    private hierarchyScopeService: HierarchyScopeService,
    private formBuilder: FormBuilder) { }

  ngOnInit(): void {
    this.buildForm();
    QRCode.toDataURL(GlobalVariables.angularURL)
      .then((url: any) => {
        this.angularProjectURL = url;
      })
      .catch((err: any) => {
        console.error('Error generating QR code', err);
      });
  }

  buildForm(): void {
    this.loginForm = this.formBuilder.group({
      email: ['', [Validators.required, /*Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")*/]],
      password: ['', [Validators.required]],
      delegateAccess: [false],
    }
    );
  }

  togglePasswordVisibility(): void {
    this.hidePassword = !this.hidePassword;
  }

  public login() {
    this.submitted = true;
    if (this.loginForm.invalid)
      return;

    var logininfo: any = {
      "email": this.f.email.value.trim(),
      "password": this.f.password.value,
      delegateAccess: this.f.delegateAccess.value,
    }

    this.loginService.login(logininfo).subscribe((res: any) => {
      if (res.success) {
        this.loginResponse = res.data;
        if (this.loginResponse.token) {
          this.hierarchyScopeService.reset();
          this.userData = this.loginResponse.userInfo;
          //console.log("country", this.userData)
          let isPWA = window.matchMedia('(display-mode: standalone)').matches;
          if (isPWA && !this.userData.userType.includes(UserTypeEnum.RETAILER)) {
            this.alertService.showError("Application access for Retail Store only!");
            this.router.navigate(['/login']);
          } else {
            this.currency = this.userData.country
            this.userFullName = this.userData.firstName + " " + this.userData.lastName;
            this.storageService.setValue(StorageKey.currentUser, JSON.stringify(this.userData));
            this.storageService.setValue(StorageKey.authToken, this.loginResponse.token);
            this.userInfoService.setUserInfo(this.userData);
            this.userInfoService.setLoginFlag(true);
            this.userInfoService.setToken(this.loginResponse.token);
            this.storageService.loginSubject.next(true);

            //checking vcard user is there  if there then generate token

            //check token is there or not
            const vcardToken = localStorage.getItem('vcardToken');

            if (!vcardToken) {
              var vcardLogin: any = {
                "email": this.f.email.value.trim(),
              }

              // this.vcardUserService.checkuser(vcardLogin).subscribe((res:any)=> {
              //     if(res.exists) {
              //       this.vcardUserService.generateToken(vcardLogin).subscribe((restok:any) => {
              //         if(restok.token) {
              //           sessionStorage.setItem('vcardUser', JSON.stringify({ token: restok.token, userInfo: restok.user }));
              //           localStorage.setItem('vcardToken', restok.token);
              //             localStorage.setItem('vcardUser', JSON.stringify(restok.user));
              //         }
              //       });
              //     } else {
              //       this.alertService.showInfo("There is no User in alyro Application");
              //     }
              // });
            }

            // end vcard generation

            if (isPartnerPortalUser(this.userData.userType) || !this.userData?.planExpired) {
              this.roleManagementService.access().subscribe((response: any) => {
                if (response.success) {
                  this.menuRights = response.data;
                  this.storageService.setValue(StorageKey.menuRights, JSON.stringify(this.menuRights));
                }
                else {
                  this.menuRights = [];
                  this.storageService.setValue(StorageKey.menuRights, JSON.stringify(this.menuRights));
                }
                this.storageService.menuListSubject.next(true);
              })
            }
            else {
              this.menuRights = [];
              this.storageService.setValue(StorageKey.menuRights, JSON.stringify(this.menuRights));
              this.storageService.menuListSubject.next(true);
            }
            if (isPartnerPortalUser(this.userData.userType)) {
              this.router.navigate(['/admin/partner-portal']);
            } else if (this.userData.userType.some((el: string) => [UserTypeEnum.ORGANIZATION_LITE, UserTypeEnum.ORGANIZATION_CATALOG].includes(el)) && !this.userData.userType.includes(UserTypeEnum.ADMIN)) {
              this.router.navigate(['/admin/products']);
            } else {
              this.router.navigate(['/admin/dashboard']);
            }
          }
        } else {
          this.storageService.loginSubject.next(false);
          this.storageService.menuListSubject.next(false);
          this.menuRights = [];
          this.storageService.setValue(StorageKey.menuRights, JSON.stringify(this.menuRights));
        }
      }
      else {
        if (res.errors && 'user_otp_pending' in res.errors) {
          const modelOTP = {
            id: res.data.userId,
            businessId: res.data.businessId,
            email: this.f.email.value.trim()
          };

          const encodedID = window.btoa(JSON.stringify(modelOTP));
          this.router.navigate(['otp-validate'], { queryParams: { ID: encodedID } });
        }
        else {
          this.storageService.loginSubject.next(false);
          this.storageService.menuListSubject.next(false);
        }
      }
    },
      (err: any) => {
        this.storageService.loginSubject.next(false);
      }
    )
  }

  // ChangeComponent(component:any){
  //   this.selectedComponent = component
  // }
  changeTab(tab:string){
    //console.log(tab);
    
    this.currentTab = tab
  }
}
